import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';
import { storeAsync } from '../../app-module';

const ApplicationsList = () => import('@/modules/applications/pages/ApplicationsList.vue');
const ApplicationsForm = () => import('@/modules/applications/pages/ApplicationsForm.vue');
const ApplicationView = () => import('@/modules/applications/pages/ApplicationView.vue');
const ApplicationEdit = () => import('@/modules/applications/pages/ApplicationEdit.vue');
const ApplicationsConfirmation = () => import('@/modules/applications/pages/ApplicationConfirmation.vue');
const ApplicationsAssignedClarificationsList = () => import('@/modules/applications/pages/ApplicationsAssignedClarificationsList.vue');
const ApplicationsAssignedList = () => import('@/modules/applications/pages/ApplicationsAssignedList.vue');
const ApplicationsToBeReviewedList = () => import('@/modules/applications/pages/ApplicationsToBeReviewedList.vue');
const ApplicationsInboxList = () => import('@/modules/applications/pages/ApplicationsInboxList.vue');
const ApplicationsInWorkList = () => import("@/modules/applications/pages/ApplicationsInWorkList.vue");
const ApplicationsCompletedList = () => import("@/modules/applications/pages/ApplicationsCompletedList.vue");
const ApplicationsWithErrorsList = () => import("@/modules/applications/pages/ApplicationsWithErrorsList.vue");
const NewApplicationsList = () => import("@/modules/applications/pages/NewApplicationsList.vue");
const ApplicationRegister = () => import("@/modules/applications/pages/ApplicationRegister");
const ApplicationCircularMail = () => import("@/modules/applications/pages/ApplicationCircularMail.vue");

const getApplicationsModule = () => import('@/modules/applications/applications-store');
const importApplicationsStore = () =>
    getApplicationsModule().then(async (storeModule) => {
        if (!storeAsync().hasModule('applications')) await storeAsync().registerModule('applications', storeModule.default);
        else return;
    });

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'applications',
                path: '/applications',
                component: ApplicationsList,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsView
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationNew',
                path: '/application/new/:appId?',
                props: true,
                component: ApplicationsForm,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationCreate
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationEdit',
                path: '/application/:id/edit',
                component: ApplicationEdit,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsView
                },
                props: true,
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationView',
                path: '/application/:id/:tab?',
                component: ApplicationView,
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsView
                },
                props: true,
            },
            {
                name: 'applicationConfirmation',
                path: '/application-confirmation/:id',
                component: ApplicationsConfirmation,
                meta: {
                    auth: true,
                },
                props: true,
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsDraft',
                path: '/applications-draft',
                component: ApplicationsList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsView,
                    filterType: 'draft'
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsSubmitted',
                path: '/applications-submitted',
                component: ApplicationsList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsView,
                    filterType: 'submitted'
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsSignPending',
                path: '/applications-sign-pending',
                component: ApplicationsList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsView,
                    filterType: 'sign_pending'
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },            
            {
                name: 'applicationsClarifications',
                path: '/applications-clarifications',
                component: ApplicationsList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsView,
                    filterType: 'clarifications'
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsFinalized',
                path: '/applications-finalized',
                component: ApplicationsList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsView,
                    filterType: 'finalized'
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsAssigned',
                path: '/applications-assigned',
                component: ApplicationsAssignedList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsStaffOwnRead
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsAssignedClarifications',
                path: '/applications-assigned-clarifications',
                component: ApplicationsAssignedClarificationsList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsStaffOwnRead
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },            
            {
                name: 'applicationsToBeReviewed',
                path: '/applications-review',
                component: ApplicationsToBeReviewedList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsStaffOwnRead
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsInbox',
                path: '/applications-inbox',
                component: ApplicationsInboxList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsStaffOwnRead
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsInWork',
                path: '/applications-in-work',
                component: ApplicationsInWorkList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsStaffOwnRead
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsCompleted',
                path: '/applications-completed',
                component: ApplicationsCompletedList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsStaffOwnRead
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationsWithErrors',
                path: '/applications-with-errors',
                component: ApplicationsWithErrorsList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsStaffOwnRead
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'newApplications',
                path: '/new-applications',
                component: NewApplicationsList,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.applicationsStaffOwnRead
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationRegister',
                path: '/register-application',
                component: ApplicationRegister,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.organisationsApplicationsRegister
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'applicationCircularMail',
                path: '/application-circular-mail/:id',
                component: ApplicationCircularMail,
                exact: true,
                meta: {
                    auth: true,
                    permission: Permissions.values.circularNotificationsCreate
                },
                beforeEnter: (to, from, next) => {
                    importApplicationsStore().then(() => {
                        next();
                    });
                },
            },
        ],
    },
];
